import {
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Inject,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    Output,
    SimpleChanges,
    ViewEncapsulation,
} from "@angular/core";
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { fuseAnimations } from "@fuse/animations";
import { FechamentoCartaConsorcioModel } from "app/auxiliares/models/fechamento-carta-consorcio.model";
import { StatusCartaConsorcioModel } from "app/auxiliares/models/status-carta-consorcio.model";
import { FechamentoCartaConsorcioService } from "app/auxiliares/services/fechamento-carta-consorcio-service";
import { StatusCartaConsorcioService } from "app/auxiliares/services/status-carta-consorcio-service";
import { BaseComponent } from "app/base-module/base-component/base.component";
import { Subscription } from "rxjs";
import { ICarta, ILance } from "../cadastro-boleta-consorcio/cadastro-boleta-consorcio.component";
import { TipoLance } from "../models/tipo-lance.model";
import { CartaBoletaConsorcioService } from "../services/carta-boleta-consorcio.service";
import { TipoLanceCartaConsorcioService } from "../services/tipo-lance-carta-consorcio.service";

export interface CadastroCartaBoletaConsorcioProps {
    cartaId: number | null;
    boletaId: number | null;
    cartaEdit: ICarta | null;
    parceiroConsorcioId: number;
}

@Component({
    selector: "app-cadasto-carta-boleta-consorcio",
    templateUrl: "./cadastro-carta-boleta-consorcio.component.html",
    styleUrls: ["./cadastro-carta-boleta-consorcio.component.scss"],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
    providers: [],
})
export class CadastroCartaBoletaConsorcio extends BaseComponent implements OnInit, OnChanges, OnDestroy {
    listFechamentoConsorcio: FechamentoCartaConsorcioModel[] = [];
    loadingSpinnerFechamentoConsorcio: boolean = false;

    listStatusCartaConsorcio: StatusCartaConsorcioModel[] = [];
    loadingSpinnerStatusCartaConsorcio: boolean = false;

    @Input()
    cartaId!: number | null;

    @Input()
    boletaId!: number | null;

    @Input()
    cartaEdit!: ICarta | null;

    @Input()
    parceiroConsorcioId!: number;

    @Output()
    addCartaEvent = new EventEmitter();

    @Output()
    saveEditCartaEvent = new EventEmitter();

    model!: ICarta;

    //carta consorcio
    cartaFormGroup: FormGroup;

    isEditCarta: boolean = false;
    selectCartaEdit: ICarta | null = null;
    selectCartaIndex: number | null = null;
    listTipoLance: TipoLance[] = [];
    loadingSpinnerTipoLance: boolean = false;

    // Adicionar estas propriedades para gerenciar recursos
    private statusChangeSubscription?: Subscription;
    private timeoutId?: number;

    constructor(
        public _service: CartaBoletaConsorcioService,
        public dialog: MatDialog,
        override snackBar: MatSnackBar,
        private fb: FormBuilder,
        private ref: ChangeDetectorRef,
        private _tipoLanceCartaService: TipoLanceCartaConsorcioService,
        private _fechamentoCartaService: FechamentoCartaConsorcioService,
        private _statusCartaService: StatusCartaConsorcioService,
        public dialogRef: MatDialogRef<CadastroCartaBoletaConsorcio>,
        @Inject(MAT_DIALOG_DATA) public data: CadastroCartaBoletaConsorcioProps
    ) {
        super(dialog, snackBar);
        this.cartaFormGroup = this.getNewFormGroup();
        if (data) {
            this.cartaId = data.cartaId;
            this.parceiroConsorcioId = data.parceiroConsorcioId;
            this.boletaId = data.boletaId;

            if (data.cartaEdit) {
                this.timeoutId = window.setTimeout(() => {
                    this.ref.markForCheck();
                    this.buildFormCarta(data.cartaEdit);
                    this.ref.detectChanges();
                }, 500);
            }
        }
    }

    /**
     * Método de inicialização da classe
     */
    ngOnInit(): void {
        this.newFormGroup();
        this.getAllTipoLance();
        this.getAllStatusCarta();
        this.getAllFechamento();
        this.addLance();
        this.setupStatusChangeListener();

        if (this.cartaId) {
            this.getById();
        }
    }

    /**
     * Configura listener para limpar data_contemplacao quando status mudar
     */
    setupStatusChangeListener(): void {
        // Finalizar subscription anterior se existir
        if (this.statusChangeSubscription) {
            this.statusChangeSubscription.unsubscribe();
        }

        this.statusChangeSubscription = this.cartaFormGroup.get("status_id")?.valueChanges.subscribe(() => {
            if (!this.isStatusContempladaFaturada()) {
                this.cartaFormGroup.get("data_contemplacao")?.setValue(null);
            }
        });
    }

    /**
     * Pega eventos de atualização dos parametros vindos do componente pai
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges): void {
        if (changes["parceiroConsorcioId"]) {
            this.getAllFechamento();
        }
        if (changes["cartaEdit"] && this.cartaEdit) {
            if (this.cartaEdit.id) {
                this.getById();
            } else {
                this.cartaFormGroup.get("id")!.setValue(this.cartaEdit.id);
                this.cartaFormGroup.get("grupo")!.setValue(this.cartaEdit.grupo);
                this.cartaFormGroup.get("cota")!.setValue(this.cartaEdit.cota);
                this.cartaFormGroup.get("prazo_grupo")!.setValue(Number(this.cartaEdit.prazo_grupo));
                this.cartaFormGroup
                    .get("taxa_administrativa_grupo")!
                    .setValue(this.cartaEdit.taxa_administrativa_grupo);
                this.cartaFormGroup.get("fechamento_id")!.setValue(this.cartaEdit.fechamento_id);
                this.cartaFormGroup.get("status_id")!.setValue(this.cartaEdit.status_id);
                this.cartaFormGroup.get("desconto")!.setValue(Number(this.cartaEdit.desconto));
                if (this.cartaEdit.data_fechamento) {
                    this.cartaFormGroup.get("data_fechamento")!.setValue(new Date(this.cartaEdit.data_fechamento));
                }
                if (this.cartaEdit.data_pagamento) {
                    this.cartaFormGroup.get("data_pagamento")!.setValue(new Date(this.cartaEdit.data_pagamento));
                }
                if (this.cartaEdit.data_contemplacao) {
                    this.cartaFormGroup.get("data_contemplacao")!.setValue(new Date(this.cartaEdit.data_contemplacao));
                }
                if (this.cartaEdit.valor_carta) {
                    this.cartaFormGroup.get("valor_carta")!.setValue(Number(this.cartaEdit.valor_carta));
                }
                if (this.cartaEdit.valor) {
                    this.cartaFormGroup.get("valor")!.setValue(Number(this.cartaEdit.valor));
                }
                // Atualizar o FormArray de Lances
                this.setLances(this.cartaEdit.lances ?? []);

                // adiciona um lance vazio para preenchimento;
                this.addLance();
            }
            this.getAllFechamento();
        }
    }

    /**
     * Exibe mensagem para forçar o usuário a selecionar um parceiro
     * @returns string
     */
    getErrorBoletaFormMessage(): string {
        return !this.parceiroConsorcioId ? "Preencha campo Parceiro da Boleta de Consórcio antes." : "";
    }

    /**
     * Consulta a carta pelo ID
     */
    getById(): void {
        this.openLoading();
        if (this.cartaId) {
            this._service.getById(this.cartaId).subscribe({
                next: (item) => {
                    this.closeLoading();
                    this.model = item.data;
                    this.buildFormCarta(item.data);
                },
                error: (error) => {
                    this.closeLoading();
                    this.showError(`Erro ao buscar carta: ${error.error?.message || error.message}`);
                },
                complete: () => {
                    // Loading será fechado em next ou error
                },
            });
        }
    }

    /**
     * Consulta lista de status da carta
     */
    getAllStatusCarta(): void {
        this.loadingSpinnerStatusCartaConsorcio = true;
        this._statusCartaService.getAll({ no_paginate: true }).subscribe({
            next: (list) => {
                this.listStatusCartaConsorcio = list.data ?? [];
            },
            error: (error) => {
                this.loadingSpinnerStatusCartaConsorcio = false;
                this.showError(`Erro ao buscar status da carta: ${error.error?.message || error.message}`);
            },
            complete: () => {
                this.loadingSpinnerStatusCartaConsorcio = false;
            },
        });
    }

    /**
     * Consulta lista de fechamentos
     */
    getAllFechamento(): void {
        if (this.parceiroConsorcioId) {
            this.loadingSpinnerFechamentoConsorcio = true;
            this._fechamentoCartaService
                .getAll({
                    no_paginate: true,
                    parceiro_id: this.parceiroConsorcioId,
                })
                .subscribe({
                    next: (list) => {
                        this.listFechamentoConsorcio = list.data;
                    },
                    error: (error) => {
                        this.loadingSpinnerFechamentoConsorcio = false;
                        this.showError(`Erro ao buscar fechamentos: ${error.error?.message || error.message}`);
                    },
                    complete: () => {
                        this.loadingSpinnerFechamentoConsorcio = false;
                    },
                });
        }
    }

    /**
     * Retorna a lista de FormArray de lances
     * @returns FormArray contendo os lances da carta
     */
    get lances(): FormArray {
        return this.cartaFormGroup.get("lances") as FormArray;
    }

    /**
     * Define os lances da carta no FormArray
     * @param lances - Lista de lances a serem adicionados ao formulário
     */
    setLances(lances: ILance[]): void {
        // Limpar os lances existentes
        this.lances.clear();

        // Adicionar os lances da carta selecionada ao FormArray
        if (lances && lances.length > 0) {
            lances.forEach((lance) => {
                if (
                    lance.tipo_lance_id !== null &&
                    !isNaN(lance.tipo_lance_id) &&
                    lance.valor_lance !== null &&
                    !isNaN(lance.valor_lance)
                ) {
                    this.lances.push(
                        this.fb.group({
                            tipo_lance_id: [lance.tipo_lance_id, Validators.required],
                            valor_lance: [lance.valor_lance, Validators.required],
                        })
                    );
                }
            });
        }
    }

    /**
     * Salva ou envia a carta para a Boleta
     */
    salvar(): void {
        if (!this.cartaId && !this.boletaId) {
            this.addCarta();
        } else {
            this.model = this.buildCarta();
            if (!this.model.id || this.cartaEdit) {
                delete this.model.id;
            }
            this.openLoading();
            if (!this.cartaId) {
                this._service.create(this.model).subscribe({
                    next: (_data) => {
                        this.closeLoading();
                        this.dialogRef.close("reload-list");
                    },
                    error: (error) => {
                        this.closeLoading();
                        this.showError(`Erro ao cadastrar carta: ${error.error?.message || error.message}`);
                    },
                    complete: () => {
                        // Loading será fechado em next ou error
                    },
                });
            } else {
                this._service.update(this.cartaId, this.model).subscribe({
                    next: (_data) => {
                        this.closeLoading();
                        this.dialogRef.close("reload-list");
                    },
                    error: (error) => {
                        this.closeLoading();
                        this.showError(`Erro ao atualizar carta: ${error.error?.message || error.message}`);
                    },
                    complete: () => {
                        // Loading será fechado em next ou error
                    },
                });
            }
        }
    }

    /**
     * Adiciona uma nova carta sem persistir no servidor
     */
    addCarta(): void {
        if (this.cartaFormGroup.invalid) {
            return;
        }
        const carta: ICarta = this.buildCarta();
        delete carta.id;
        this.dialogRef.close({ carta });
    }

    /**
     * Salva as alterações da carta em edição e emite evento
     */
    saveEditCarta(): void {
        if (this.cartaFormGroup.invalid) {
            return;
        }
        this.selectCartaEdit = null;
        this.isEditCarta = false;
        this.loadingIndicator = false;
        this.saveEditCartaEvent.emit(this.buildCarta());
    }

    /**
     * Cria um novo FormGroup para o formulário de carta
     * @returns FormGroup configurado com todos os campos da carta
     */
    getNewFormGroup(): FormGroup {
        return this.fb.group({
            id: new FormControl(null, []),
            grupo: new FormControl("", [Validators.required]),
            cota: new FormControl("", [Validators.required]),
            prazo_grupo: new FormControl(null, [Validators.required]),
            taxa_administrativa_grupo: new FormControl(0),
            fechamento_id: new FormControl(),
            status_id: new FormControl(),
            desconto: new FormControl(0),
            data_fechamento: new FormControl(),
            data_pagamento: new FormControl(),
            valor_carta: new FormControl(0),
            lances: this.fb.array([]),
            valor: new FormControl(0),
            data_contemplacao: new FormControl(),
        });
    }

    /**
     * Reinicializa o FormGroup da carta com valores padrão
     */
    newFormGroup(): void {
        this.cartaFormGroup = this.getNewFormGroup();
    }

    /**
     * Calcula o valor total de todos os lances considerando tipo percentual ou fixo
     * @returns Valor total calculado dos lances
     */
    getValorTotalLances(): number {
        return this.lances.controls.reduce((acc, item) => {
            if (item.value.valor_lance > 0) {
                const tipo_valor = this.getTipoLanceById(item.value.tipo_lance_id);
                if (tipo_valor?.tipo_valor === "percent") {
                    return (
                        Number(acc) +
                        (Number(item.value.valor_lance) / 100) * Number(this.cartaFormGroup.get("valor_carta")!.value)
                    );
                }
                return Number(acc) + Number(item.value.valor_lance);
            }
            return Number(acc) + 0;
        }, 0);
    }

    /**
     * Cria um novo FormGroup para um lance vazio
     * @returns FormGroup configurado para um lance
     */
    newLance(): FormGroup {
        return this.fb.group({
            tipo_lance_id: "",
            valor_lance: "",
        });
    }

    /**
     * Adiciona um novo lance vazio ao FormArray
     */
    addLance(): void {
        this.lances.push(this.newLance());
    }

    /**
     * Remove um lance do FormArray pelo índice
     * @param index - Índice do lance a ser removido
     */
    removeLance(index: number): void {
        this.lances.removeAt(index);
    }

    /**
     * Retorna o FormGroup de um lance específico pelo índice
     * @param index - Índice do lance
     * @returns FormGroup do lance ou undefined se não encontrado
     */
    getLance(index: number): FormGroup | undefined {
        return this.lances.controls[index] as FormGroup | undefined;
    }

    /**
     * Consulta lista de tipos de lance
     */
    getAllTipoLance(): void {
        this.loadingSpinnerTipoLance = true;
        this._tipoLanceCartaService.getAll({}).subscribe({
            next: (list) => {
                this.listTipoLance = list.data ?? [];
                this.loadingSpinnerTipoLance = false;
            },
            error: (error) => {
                this.loadingSpinnerTipoLance = false;
                this.showError(`Erro ao buscar tipos de lance: ${error.error?.message || error.message}`);
            },
            complete: () => {
                // Loading será fechado em next ou error
            },
        });
    }

    /**
     * Busca um tipo de lance pelo ID
     * @param id - Identificador do tipo de lance
     * @returns Tipo de lance encontrado ou undefined
     */
    getTipoLanceById(id: number): TipoLance | undefined {
        return this.listTipoLance.find((item) => item.id === id);
    }

    /**
     * Verifica se o status selecionado é "Contemplada/Faturada"
     * @returns boolean - true se o status for "Contemplada/Faturada"
     */
    isStatusContempladaFaturada(): boolean {
        const statusId = this.cartaFormGroup.get("status_id")?.value;
        if (!statusId) {
            return false;
        }
        const status = this.listStatusCartaConsorcio.find((item) => item.id === statusId);
        return (
            status?.nome?.toLowerCase().includes("contemplada") ||
            status?.nome?.toLowerCase().includes("faturada") ||
            false
        );
    }

    /**
     * Retorna o símbolo do tipo de valor do lance (percentual ou fixo)
     * @param i - Índice do lance no FormArray
     * @returns Símbolo "% " para percentual ou "R$ " para valor fixo
     */
    getSimboloTipoValor(i: number): string {
        const tipo_lance = this.getTipoLanceById(this.getLance(i)?.value.tipo_lance_id);
        if (tipo_lance) {
            return tipo_lance.tipo_valor === "percent" ? "% " : "R$ ";
        }
        return "R$ ";
    }

    /**
     * Retorna as opções de formatação para o campo de valor do lance
     * @param i - Índice do lance no FormArray
     * @returns Objeto com opções de formatação de moeda
     */
    getOptionsTypeValue(i: number): { prefix: string; thousands: string; decimal: string; align: string } {
        return {
            prefix: this.getSimboloTipoValor(i),
            thousands: ".",
            decimal: ",",
            align: "center",
        };
    }

    /**
     * Fecha o diálogo sem salvar alterações
     */
    onNoClick(): void {
        this.dialogRef.close("cancel");
    }

    /**
     * Constrói o objeto ICarta a partir dos valores do formulário
     * @returns Objeto ICarta preenchido com os dados do formulário
     */
    buildCarta(): ICarta {
        const carta: ICarta = {
            grupo: this.cartaFormGroup.get("grupo")!.value,
            cota: this.cartaFormGroup.get("cota")!.value,
            prazo_grupo: this.cartaFormGroup.get("prazo_grupo")!.value,
            taxa_administrativa_grupo: this.cartaFormGroup.get("taxa_administrativa_grupo")!.value,
            fechamento_id: this.cartaFormGroup.get("fechamento_id")!.value,
            status_id: this.cartaFormGroup.get("status_id")!.value,
            desconto: this.cartaFormGroup.get("desconto")!.value,
            data_fechamento: this.cartaFormGroup.get("data_fechamento")!.value,
            data_pagamento: this.cartaFormGroup.get("data_pagamento")!.value,
            valor_carta: this.cartaFormGroup.get("valor_carta")!.value,
            valor: this.getValorTotalLances(),
            lances: this.lances.value,
            boleta_id: this.boletaId,
            id: this.cartaId,
            data_contemplacao: this.cartaFormGroup.get("data_contemplacao")?.value || null,
        };

        return carta;
    }

    /**
     * Preenche o formulário com os dados de uma carta existente
     * @param data - Dados da carta a serem carregados no formulário
     */
    buildFormCarta(data: ICarta | null): void {
        if (!data) return;

        this.cartaFormGroup.get("grupo")!.setValue(data.grupo);
        this.cartaFormGroup.get("cota")!.setValue(data.cota);
        this.cartaFormGroup.get("prazo_grupo")!.setValue(data.prazo_grupo);
        this.cartaFormGroup.get("taxa_administrativa_grupo")!.setValue(data.taxa_administrativa_grupo);
        this.cartaFormGroup.get("fechamento_id")!.setValue(data.fechamento_id);
        this.cartaFormGroup.get("status_id")!.setValue(data.status_id);
        this.cartaFormGroup.get("desconto")!.setValue(data.desconto);
        this.cartaFormGroup
            .get("data_fechamento")!
            .setValue(data.data_fechamento ? new Date(data.data_fechamento) : "");
        this.cartaFormGroup.get("data_pagamento")!.setValue(data.data_pagamento ? new Date(data.data_pagamento) : "");
        this.cartaFormGroup.get("valor_carta")!.setValue(data.valor_carta);
        if (data.data_contemplacao) {
            this.cartaFormGroup
                .get("data_contemplacao")!
                .setValue(data.data_contemplacao ? new Date(data.data_contemplacao) : "");
        }
        this.setLances(data.lances ?? []);
    }

    /**
     * Limpa recursos quando o componente é destruído
     */
    ngOnDestroy(): void {
        // Finalizar subscription do valueChanges
        if (this.statusChangeSubscription) {
            this.statusChangeSubscription.unsubscribe();
            this.statusChangeSubscription = undefined;
        }

        // Limpar timeout se ainda estiver pendente
        if (this.timeoutId !== undefined) {
            clearTimeout(this.timeoutId);
            this.timeoutId = undefined;
        }

        // Fechar loading dialog se estiver aberto
        try {
            if (this.loadingTest) {
                this.loadingTest.close();
                this.loadingTest = undefined;
            }
        } catch {
            // Ignorar erro se já foi fechado ou destruído
        }
    }
}
